import React from 'react'
import MaskedInput from 'react-text-mask'

const regex = {
  phoneNumber: /([0-9]{2})([0-9]{8,9})/,
  phoneNumberWithDdi: /([0-9]{2})([0-9]{2})([0-9]{8,9})/,
  companyTaxDocument: /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([0-9]{2})/i,
  taxDocument: /([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})/
}

// prettier-ignore
const masks = {
  phoneAreaCode: [/\d/, /\d/],
  phoneNumber: (rawValue: string) =>
    rawValue.replace(/[^\d]/g, '').length > 8
      ? [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      : [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  phoneNumberWithCode: (rawValue: string) =>
    rawValue.replace(/[^\d]/g, '').length > 10
      ? ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
      : ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  taxDocumentCPF: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
  taxDocumentCNPJ: [/[A-Z0-9]/i, /[A-Z0-9]/i, '.', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '.', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '/', /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, /[A-Z0-9]/i, '-', /\d/, /\d/],
  taxDocumentCPFCNPJ: (rawValue: string) =>
    rawValue.replace(/[^A-Z0-9]/gi, '').length > 11 || /[A-Z]/i.test(rawValue)
      ? masks.taxDocumentCNPJ
      : masks.taxDocumentCPF,
  postcode: (rawValue: string) =>
    rawValue.replace(/[^\d]/g, '').length > 7
      ? [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
      : [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
  creditCardNumber: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  creditCardNumberAmex: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/],
  creditCardNumberDiners: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  creditCardValidDate: [/\d/, /\d/, '/', /\d/, /\d/],
  currencyBRL: (rawValue: string) => {
    if (rawValue.length < 3) return [/\d/, /\d/]
    const newValue: any = [...rawValue.replace(/^0+/g, '').replace(/[^\d]/g, '')].map((_, i) =>
      i === 0 ? /[1-9]/ : /\d/
    )
    newValue.splice(-2, 0, ',')
    if (newValue.length > 6) newValue.splice(-6, 0, '.')
    if (newValue.length > 10) newValue.splice(-10, 0, '.')
    if (newValue.length > 14) newValue.splice(-14, 0, '.')
    if (newValue.length > 16) newValue.splice(-16, 1)
    return newValue
  },
  birthdate: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
}

const creditCardNumberMultiple = (rawValue: string) =>
  rawValue.replace(/[^\d]/g, '').length === 14
    ? masks.creditCardNumberDiners
    : rawValue.replace(/[^\d]/g, '').length === 15
      ? masks.creditCardNumberAmex
      : masks.creditCardNumber

const uppercasePipe = (conformedValue: string) => conformedValue.toUpperCase()

const TextMaskInput = (props: any) => {
  const { mask, inputRef, ...restProps } = props
  return (
    // @ts-ignore
    <MaskedInput
      mask={mask}
      guide={false}
      ref={ref => inputRef?.(ref ? ref.inputElement : null)}
      {...restProps}
    />
  )
}

const withMask = (mask: any, pipe?: (value: string) => string) =>
  React.forwardRef((props, ref) => (
    <TextMaskInput mask={mask} inputRef={ref} pipe={pipe} {...props} />
  ))

const MaskedPhoneAreaCode = withMask(masks.phoneAreaCode)
const MaskedPhoneNumber = withMask(masks.phoneNumber)
const MaskedPhoneNumberWithCode = withMask(masks.phoneNumberWithCode)
const MaskedTaxDocumentCPF = withMask(masks.taxDocumentCPF)
const MaskedTaxDocumentCNPJ = withMask(masks.taxDocumentCNPJ, uppercasePipe)
const MaskedTaxDocumentCPFCNPJ = withMask(masks.taxDocumentCPFCNPJ, uppercasePipe)
const MaskedPostcode = withMask(masks.postcode)
const MaskedCreditCardNumber = withMask(masks.creditCardNumber)
const MaskedCreditCardNumberAmex = withMask(masks.creditCardNumberAmex)
const MaskedCreditCardNumberDiners = withMask(masks.creditCardNumberDiners)
const MaskedCreditCardNumberMultiple = withMask(creditCardNumberMultiple)
const MaskedCreditCardValidDate = withMask(masks.creditCardValidDate)
const MaskedCurrencyBRL = withMask(masks.currencyBRL)
const MaskedBirthdate = withMask(masks.birthdate)

export {
  MaskedBirthdate,
  MaskedCreditCardNumber,
  MaskedCreditCardNumberAmex,
  MaskedCreditCardNumberDiners,
  MaskedCreditCardNumberMultiple,
  MaskedCreditCardValidDate,
  MaskedCurrencyBRL,
  MaskedPhoneAreaCode,
  MaskedPhoneNumber,
  MaskedPhoneNumberWithCode,
  MaskedPostcode,
  MaskedTaxDocumentCNPJ,
  MaskedTaxDocumentCPF,
  MaskedTaxDocumentCPFCNPJ,
  regex
}
